const data = {
  mainRoutes: [
    {
      id: 'gift',
      label: 'GIFT',
      route: '/gift/',
    },
    {
      label: 'LOGIN',
      route: ' ',
      subdomain: 'login',
      id: 'login',
    },
  ],
  buttonRoutes: [
    {
      id: 'gtb',
      label: 'Get The Box',
      route: {
        route: '/get-the-box/?step=getbox#plan=fffvip',
        subdomain: false,
        inApp: false,
      },
    },
  ],
};

export default data;
